import { styled } from 'styled-components';
import { Image } from '@/shared/ui/image';
import { WRAPPER } from '@/shared/styles/themes';

export const ParallaxImageFirst = styled(Image)`
  position: sticky;
  top: 0;
`;

export const ParallaxImageSecond = styled(Image)`
  position: absolute !important;
  left: 0 !important;
  bottom: 0 !important;
`;

export const ParallaxWrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: -1;
  will-change: transform;
`;

export const Wrapper = styled.div`
  width: 100%;
`;
export const TitleH1 = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  @media (max-width: 768px) {
    margin: 24px 18px;
  }
`;

export const InstallBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: radial-gradient(
    60.63% 121.25% at 50% 0%,
    rgba(31, 120, 255, 1) 0%,
    rgba(10, 49, 255, 1) 100%
  );
  position: relative;
  z-index: 1;
`;

export const CloseIcon = styled(Image)`
  position: absolute;
  right: 12px;
  top: 6px;
  cursor: pointer;
`;

export const ContentRows = styled.div`
  ${WRAPPER};
  display: flex;
  margin-bottom: 32px;
  gap: 12px;
  @media (max-width: 768px) {
    display: flex;
    gap: 8px;
    scroll-behavior: smooth;
    margin-left: 12px;
    overflow: scroll;
    margin-top: 24px;
    padding-bottom: 12px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;
